(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		//this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();

		this.isProductPage = true
	}

	hide() {
		super.hide(this.isProductPage);
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();		
	}

	showActiveMedia() {
		console.log('🔍 showActiveMedia called');
		
		// Get the color from the clicked media item in the main gallery
		const clickedMediaId = this.openedBy.getAttribute("data-media-id");
		console.log('Clicked media ID:', clickedMediaId);
		
		const mainGallery = document.querySelector('.product__media-list, .js-media-list');
		
		let selectedColor = null;
		
		if (mainGallery && clickedMediaId) {
			// Find the media item by data-media-id, check both button and parent
			const clickedMediaElement = mainGallery.querySelector(`[data-media-id="${clickedMediaId}"]`);
			console.log('Clicked element:', clickedMediaElement);
			
			if (clickedMediaElement) {
				// Try to get color from the element itself
				selectedColor = clickedMediaElement.getAttribute('data-color');
				console.log('Color from element:', selectedColor);
				
				// If not found, try parent element (the actual media item)
				if (!selectedColor && clickedMediaElement.parentElement) {
					selectedColor = clickedMediaElement.parentElement.getAttribute('data-color');
					console.log('Color from parent:', selectedColor);
				}
				
				// If still not found, try closest .product__media-item
				if (!selectedColor) {
					const mediaItem = clickedMediaElement.closest('.product__media-item');
					if (mediaItem) {
						selectedColor = mediaItem.getAttribute('data-color');
						console.log('Color from .product__media-item:', selectedColor);
					}
				}
				
			}
		}
		
		console.log('✅ Final selected color:', selectedColor);
		
		// If no color found from clicked element, get from variant selector
		if (!selectedColor) {
			const variantSelector = document.querySelector('variant-selects, variant-radios');
			
			if (variantSelector) {
				const colorRadio = variantSelector.querySelector('.js-radio-colors input:checked');
				
				if (colorRadio) {
					selectedColor = colorRadio.value.toLowerCase().trim();
				} else {
					// Try to find active color swatch another way
					const activeColorSwatch = variantSelector.querySelector('.js-radio-colors .active-color, .js-radio-colors input[checked]');
					if (activeColorSwatch) {
						selectedColor = activeColorSwatch.value ? activeColorSwatch.value.toLowerCase().trim() : null;
					}
				}
			}
		}
		
		
		// Filter modal items by color
		const modalItems = this.querySelectorAll('.product-media-modal__item');
		console.log('Total modal items:', modalItems.length);
		
		let visibleCount = 0;
		modalItems.forEach((item, index) => {
			const itemColor = item.getAttribute('data-color');
			const shouldShow = !itemColor || itemColor === '' || !selectedColor || itemColor === selectedColor;
			
			console.log(`Item ${index}: color="${itemColor}", shouldShow=${shouldShow}`);
			
			// Show item if no color attribute or color matches selected color
			if (shouldShow) {
				item.style.display = '';
				visibleCount++;
			} else {
				item.style.display = 'none';
			}
		});
		
		console.log(`✅ Visible items: ${visibleCount} / ${modalItems.length}`);
		
		// Show active media and scroll to it
		const activeMedia = this.querySelector(`[data-media-modal-id$="-${clickedMediaId}"]`);
		
		if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
		}
		if (activeMedia && activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);

// Filter gallery images by color on variant change
(function() {
	function filterGalleryByColor() {
		const variantSelector = document.querySelector('variant-selects, variant-radios');
		if (!variantSelector) return;
		
		// Get selected color
		let selectedColor = null;
		const activeColorSwatch = variantSelector.querySelector('.js-radio-colors .active-color, .js-radio-colors input[checked]');
		if (activeColorSwatch) {
			selectedColor = activeColorSwatch.value ? activeColorSwatch.value.toLowerCase().trim() : null;
		}
		
		// Filter gallery images
		const galleryItems = document.querySelectorAll('.product__media-item');
		galleryItems.forEach(item => {
			const itemColor = item.getAttribute('data-color');
			const shouldShow = !itemColor || itemColor === '' || !selectedColor || itemColor === selectedColor;
			
			if (shouldShow) {
				item.style.display = '';
			} else {
				item.style.display = 'none';
			}
		});
	}
	
	// Listen for variant changes
	document.addEventListener('DOMContentLoaded', function() {
		filterGalleryByColor(); // Initial filter
		
		// Listen for variant change events
		document.addEventListener('variant:change', filterGalleryByColor);
		
		// Also listen for radio button changes (for variant-radios)
		const variantSelector = document.querySelector('variant-selects, variant-radios');
		if (variantSelector) {
			variantSelector.addEventListener('change', function() {
				setTimeout(filterGalleryByColor, 100);
			});
		}
	});
})();


  } catch(e) { console.error(e); }
})();
})();
